import { render, staticRenderFns } from "./setRealnameTicket.vue?vue&type=template&id=7adb179c&scoped=true&"
import script from "./setRealnameTicket.vue?vue&type=script&lang=js&"
export * from "./setRealnameTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb179c",
  null
  
)

export default component.exports